/**
 * 各种属性校验规则
 * 为了统一给非组件使用
 */
export default (type, app) => {
  const checkImgNavNum = function(rule, value, callback, source) {
    // 特殊的样式要限制数量
    const len = source.navs.length;
    if (!len) {
      callback(new Error('七巧板添加的图片数量不足'));
    } else {
      if (source.styleType !== 5 && len % source.styleType !== 0) {
        callback(
          new Error(`七巧板当前图片数量未满足一行${source.styleType}个`)
        );
      } else {
        // 链接校验
        const isOtherMiniErr = source.navs.find(
          t => !utils.checkSystemLink(t.linkItem)
        );
        if (isOtherMiniErr) {
          callback(new Error('链接绑定的外部小程序数据未填写完整'));
        } else {
          callback();
        }
      }
    }
  };
  // footer
  const checkFooterNum = function(rule, value, callback, source) {
    // 特殊的样式要限制数量
    if (source.iconStyleType === 2 && ![3, 5].includes(value.length)) {
      callback(new Error('当前编辑的底部导航样式图标数量必须为3个或5个'));
    } else if (value.length) {
      callback();
    } else {
      callback(new Error());
    }
  };
  // 优惠券
  const checkCoupon = function(rule, value, callback, source) {
    // 特殊的样式要限制数量
    if (source.list.length === 0) {
      callback(new Error('优惠券不能为空'));
    } else if (value.length) {
      callback();
    } else {
      callback(new Error());
    }
  };
  // 满减邮
  const checkfreeShiping = function(rule, value, callback, source) {
    // 特殊的样式要限制数量
    if (source.activeList.length === 0) {
      callback(new Error('满减邮活动不能为空'));
    } else if (value.length) {
      callback();
    } else {
      callback(new Error());
    }
  };
  // 满减送
  const checkFullReduction = function(rule, value, callback, source) {
    if (source.activeList.length === 0) {
      callback(new Error('满减送活动不能为空'));
    } else if (value.length) {
      callback();
    } else {
      callback(new Error());
    }
  };
  // 限时秒杀
  const checkSecKill = function(rule, value, callback, source) {
    if (source.activeList.length === 0) {
      callback(new Error('限时秒杀活动不能为空'));
    } else if (value.length) {
      callback();
    } else {
      callback(new Error());
    }
  };

  // 拼团组件
  const groupBuying1 = function(rule, value, callback, source) {
    // 特殊的样式要限制数量
    if (source.setting.groupActivities.length === 0) {
      callback(new Error('拼团活动不能为空'));
    } else {
      callback();
    }
  };
  // 店铺导航
  const checkNavs = function(rule, value, callback, source) {
    // source拿不到完整表单!  https://github.com/ElemeFE/element/issues/19240
    const maxLimit = app.maxLimit ? app.maxLimit : source.styleType * 5;
    if (value.length < maxLimit + 1) {
      callback();
    } else {
      callback(
        new Error(
          app.$t('shopDecoration.home.controls.AddNavMaxTip', {
            n: maxLimit,
          })
        )
      );
    }
  };

  const checkLinkItem = (rule, value, callback) => {
    // 获取当前链接
    const curLink = utils.getCurLinkByItem(value);
    if (curLink) {
      callback();
    } else {
      // 细分错误...要求比较高
      const isOtherMiniErr = !utils.checkSystemLink(value);
      if (isOtherMiniErr) {
        callback(new Error('链接绑定的外部小程序数据未填写完整'));
      } else {
        callback(new Error('链接必填'));
      }
    }
  };
  // 非必填 但是外部小程序链接必须填写完整
  const checkNavFile = (rule, value, callback) => {
    // string or obj
    const isOtherMiniErr = utils.checkSystemLink(value);
    if (isOtherMiniErr) {
      callback();
    } else {
      callback(new Error('链接绑定的外部小程序数据未填写完整'));
    }
  };

  const shopNav = {
    navs: {
      type: 'array',
      required: true,
      validator: checkNavs,
      defaultField: {
        type: 'object',
        required: true,
        fields: {
          linkItem: {
            validator: checkLinkItem,
            required: true,
          },
          name: {
            type: 'string',
            required: true,
            message: app.$t('shopDecoration.home.controls.navNameRequired'),
          },
          iconFile: {
            type: 'object',
            required: true,
            message: app.$t('shopDecoration.home.controls.iconRequired'),
          },
        },
      },
    },
  };

  // banner
  const banner = {
    imgs: {
      type: 'array',
      required: true,
      defaultField: {
        type: 'object',
        required: true,
        fields: {
          file: {
            type: 'object',
            required: true,
            message: app.$t('shopDecoration.home.controls.choosePic'),
          },
          linkItem: {
            validator: checkNavFile,
            required: true,
          },
        },
      },
    },
  };
  // imgNav
  const imgNav = {
    navs: {
      type: 'array',
      validator: checkImgNavNum,
      // defaultField: {
      //   type: 'object',
      //   required: true,
      //   fields: {
      //     file: {
      //       type: 'object',
      //       required: true,
      //       message: app.$t('shopDecoration.home.controls.choosePic'),
      //     },
      //   },
      // },
    },
    styleType: {
      type: 'number',
      required: true,
      message: '排列方式必填',
    },
  };

  // titleBar
  const titleBar = {
    name: {
      type: 'string',
      required: true,
      message: app.$t('shopDecoration.home.controls.titleNameRequired'),
    },
    linkItem: {
      validator: checkNavFile,
      required: true,
    },
  };

  // category
  const category = {
    groups: {
      type: 'array',
      required: true,
      defaultField: {
        type: 'object',
        required: true,
        fields: {
          id: {
            type: 'number',
            required: true,
            message:
              '请选择' + app.$t('shopDecoration.home.controls.goodsFrom'),
          },
        },
      },
    },
    goodsListProps: {
      type: 'object',
      required: true,
      fields: {
        showContent: {
          type: 'array',
          required: true,
          message: '显示内容必填',
        },
      },
    },
  };

  // category
  const goods = {
    goodsListProps: {
      type: 'object',
      required: true,
      fields: {
        showContent: {
          type: 'array',
          required: true,
          message: '显示内容必填',
        },
      },
    },
  };
  const coupon = {
    list: {
      type: 'array',
      required: true,
      validator: checkCoupon,
    },
  };
  // 拼团
  const groupBuying = {
    activeList: {
      type: 'array',
      required: true,
      validator: groupBuying1,
    },
  };
  const freeShipping = {
    activeList: {
      type: 'array',
      required: true,
      validator: checkfreeShiping,
    },
  };
  // 满减送
  const fullReduction = {
    activeList: {
      type: 'array',
      required: true,
      validator: checkFullReduction,
    },
    // mainImg: {
    //   required: true,
    //   validator(rule, value, callback, source) {
    //     const { heardStyleType } = source.goodsListProps;
    //     // 满减送样式选择3不需要上传底图
    //     if (source.mainImgs.length === 0 && heardStyleType !== 3) {
    //       callback(new Error('请设置满减送活动底图'));
    //     } else {
    //       callback();
    //     }
    //   },
    // },
    showGoodsCount: {
      required: true,
      validator(rule, value, callback, source) {
        if (source.showGoodsCount < 0) {
          // 商品个数可以为 0
          callback(new Error('商品个数不能小于0'));
        } else {
          callback();
        }
      },
    },
  };
  // 限时秒杀
  const secKill = {
    activeList: {
      type: 'array',
      required: true,
      validator: checkSecKill,
    },
    // 可以不传，如果不传就不展示图片
    // mainImg: {
    //   required: true,
    //   validator(rule, value, callback, source) {
    //     const { heardStyleType } = source.goodsListProps;
    //     // 秒杀样式选择3可以不不需要上传底图
    //     if (source.mainImgs.length === 0 && heardStyleType !== 3) {
    //       callback(new Error('请设置限时秒杀活动底图'));
    //     } else {
    //       callback();
    //     }
    //   },
    // },
    showGoodsCount: {
      required: true,
      validator(rule, value, callback, source) {
        if (source.showGoodsCount < 0) {
          // 商品个数可以为 0
          // if (!source.showGoodsCount || source.showGoodsCount < 0) {
          // callback(new Error('请设置限时秒杀活动商品个数'));
          callback(new Error('商品个数不能小于0'));
        } else {
          callback();
        }
      },
    },
  };
  const footerNav = {
    tableData: {
      type: 'array',
      // 不能写 不然无法校验
      // defaultField: {
      //   type: 'object',
      //   required: true,
      // },
      validator: checkFooterNum,
    },
    iconStyleType: {
      type: 'number',
      required: true,
      message: '显示内容必填',
    },
  };
  // 倒计时
  const countDown = {
    time: {
      type: 'array',
      required: true,
      message: '请选择倒计时日期',
      trigger: 'change',
    },
    imgUrl: {
      validator(rule, value, callback, source) {
        const { backgroundColorType } = source;
        if (backgroundColorType && !value) {
          callback(new Error('请选择倒计时背景图片'));
        }
        callback();
      },
    },
  };
  return {
    store: {}, // 门店模块无组件属性设置，故不需要校验
    searchBar: {}, // empty
    video: {},
    // 应需求 所有都无规则校验
    banner,
    titleBar,
    category,
    goods: {},
    // 底部这还是要的..
    footerNav,
    freeShipping,
    // 团购
    groupBuying,
    coupon,
    shopNav,
    imgNav,
    fullReduction,
    secKill,
    // brand,
    brand: {},
    countDown,
  }[type];
};
